import { FC, useState } from 'react';
import { DataSource, DataSourceSFTPConfig } from '@/models/dataSource';
import { useAppDispatch, useAppSelector } from '@/reducers';
import { stashDataSource } from '@/features/dataSources/dataSourcesSlice';
import { StepPageActions } from '@/global/components';
import { CSVRowIsHeaderOrItem } from '@/features/dataSources/components/commons/CSVRowIsHeaderOrItem';
import { CSVFileDataTable } from '@/features/dataSources/components/commons/CSVFileDataTable';

const DEFAULT_HEADER = 'defaultHeader';
const ITEM_HEADER = 'itemHeader';

type SFTPCSVHeaderStepStepProps = {
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  onCancel?: VoidFunction;
};

export const SFTPCSVHeaderStep: FC<SFTPCSVHeaderStepStepProps> = ({ onNextStep, onPrevStep }) => {
  const dispatch = useAppDispatch();

  const dataSource = useAppSelector((state) => state.dataSources.edit?.dataSource) as Partial<DataSource<DataSourceSFTPConfig>> | undefined;
  const csvFileData = useAppSelector((state) => state.fileUploading.fileData);
  const [csvHeader, setCSVHeader] = useState<string>(csvFileData?.isDefaultHeader ? DEFAULT_HEADER : ITEM_HEADER);

  const handleNextStep = () => {
    if (dataSource && dataSource.configuration && csvFileData?.isDefaultHeader !== undefined) {
      dispatch(stashDataSource({ configuration: { ...dataSource.configuration, isDefaultHeader: csvFileData.isDefaultHeader } }));
      onNextStep();
    }
  };

  return (
    <>
      <div className='flex flex-col gap-8'>
        <CSVRowIsHeaderOrItem csvHeader={csvHeader} onTypeChange={setCSVHeader} />

        <CSVFileDataTable csvFileData={csvFileData} csvHeader={csvHeader} />
      </div>

      <StepPageActions
        primaryButton={{
          text: 'COMMON.confirm',
          onClick: handleNextStep,
        }}
        secondaryButton={{
          text: 'COMMON.cancel',
          onClick: onPrevStep,
        }}
      />
    </>
  );
};
